import { styled } from '@mui/material/styles';

export const Root = styled('div')(({ theme }) => ({
	display: 'grid',
	gridAutoFlow: 'column',
	gridTemplateRows: '1fr max-content',
	...theme.typography.body2,
	color: theme.palette.neutral[80],

	'& > span:last-of-type': {
		marginTop: 8,
	},
}));

export const TextWrapper = styled('div')(({ theme }) => ({
	display: 'flex',
	alignItems: 'center',
	...theme.typography.body1,
	color: theme.palette.neutral[100],
	height: 'fit-content',

	'& > div': {
		marginLeft: 8,
		display: 'grid',
		alignItems: 'center',
	},
}));
